import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SnackbarUtils from 'utils/SnackbarUtils';
import CustomIconButton from '../../../../../../components/CustomIconButton/CustomIconButton';
import CloudDownloadIcon from '../../../../../../components/Icons/CloudDownloadIcon';
import RefreshIcon from '../../../../../../components/Icons/RefreshIcon';
import ProgressModal from '../../../../../../components/ProgressModal/ProgressModal';
import {
  CONTRATO_VERSAO_ADITIVO,
  CONTRATO_VERSAO_ADITIVO_NAME,
  CONTRATO_VERSAO_CONTRATO,
  CONTRATO_VERSAO_CONTRATO_NAME,
  CONTRATO_VERSAO_DISTRATO,
  CONTRATO_VERSAO_DISTRATO_NAME,
} from '../../../../../../library/ContratoVersoes';
import { downloadContrato } from '../../../../../../store/modules/ContratosAssessoresActions';
import {
  changeModalProps,
  closeModal,
  openModal,
} from '../../../../../../store/modules/ModalActions';
import { getElementID } from '../../../../../../utils/HTMLUtils';
import arquivosStyles from '../Arquivos.scss';

const INITIAL_STATE = {
  modalKey: null,
};

class DownloadAssinadoButton extends Component {
  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;
  }

  getArquivoId = () => {
    return this.props.arquivo.idDocAssinado;
  };

  closeModal = () => {
    this.props.closeModal(this.state.modalKey);
    this.setState({
      modalKey: null,
    });
  };

  onCallbackProgress = (event) => {
    const percent = (event.loaded * 1) / event.total;
    if (this.state.modalKey) {
      this.props.changeModalProps(this.state.modalKey, {
        percent: percent,
      });
    }
  };

  getFileName = () => {
    const arquivo = this.props.arquivo;
    let fileName = '';
    switch (arquivo.versaoContrato) {
      case CONTRATO_VERSAO_ADITIVO:
        fileName = CONTRATO_VERSAO_ADITIVO_NAME;
        break;
      case CONTRATO_VERSAO_DISTRATO:
        fileName = CONTRATO_VERSAO_DISTRATO_NAME;
        break;
      case CONTRATO_VERSAO_CONTRATO:
      default:
        fileName = CONTRATO_VERSAO_CONTRATO_NAME;
        break;
    }
    return (
      fileName +
      '-' +
      arquivo.codigo.split('/').join('-') +
      '-data-' +
      moment().format('DD-MM')
    );
  };

  onCallbackSuccess = (resp) => {
    const blob = new Blob([resp.data], {
      type: 'application/pdf',
    });
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = this.getFileName();
    link.class = 'hidden-button';
    document.body.appendChild(link);
    link.click();
    link.remove();

    this.closeModal();
    SnackbarUtils.enqueueSnackbar({
      message: this.props.languageValues.successDownloadDocumentoAssinado,
      options: {
        variant: 'success',
      },
    });
  };

  onCallbackError = (error) => {
    this.closeModal();
    SnackbarUtils.enqueueSnackbar({
      message:
        error.response.statusText ||
        this.props.languageValues.errorDownloadDocumentoAssinado,
      options: {
        variant: 'error',
      },
    });
  };

  download = () => {
    const modalKey = this.props.openModal(ProgressModal, {
      title:
        this.props.languageValues.cadastroContratoArquivosDownloadingAssinado,
      percent: 0,
    }).payload.key;

    this.setState(
      {
        modalKey,
      },
      () => {
        this.props.downloadContrato(
          this.getArquivoId(),
          this.onCallbackProgress,
          (resp) => this.onCallbackSuccess(resp),
          this.onCallbackError
        );
      }
    );
  };

  onClick = () => {
    this.download();
  };

  isLoading = () => {
    return this.props.contratosAssessores.loadingAlteraStatus;
  };

  isDisabled = () => {
    const arquivo = this.props.arquivo;
    return (
      this.isLoading() ||
      !arquivo.ativo ||
      !this.getArquivoId() ||
      arquivo.idDocAssinado == null ||
      this.props.contratosAssessores.loadingAlteraArquivo
    );
  };

  render() {
    const arquivo = this.props.arquivo;
    return arquivo ? (
      <CustomIconButton
        id={getElementID(this.props.id, 'download-assinado-' + arquivo.id)}
        className={arquivosStyles.rootClassName + '-action-button'}
        onClick={() => this.onClick()}
        tooltipProps={{
          className:
            arquivosStyles.rootClassName + '-action-button-tooltip-caller',
        }}
        size='small'
        tooltip={
          this.props.languageValues.cadastroContratoArquivosDownloadAssinado
        }
        icon={this.isLoading() ? <RefreshIcon /> : <CloudDownloadIcon />}
        disabled={this.isDisabled()}
      />
    ) : null;
  }
}

DownloadAssinadoButton.propTypes = {
  id: PropTypes.string.isRequired,
  refreshStep: PropTypes.func.isRequired,
  arquivo: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  contratos: state.contratos,
  contratosAssessores: state.contratosAssessores,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      downloadContrato,
      openModal,
      closeModal,
      changeModalProps,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DownloadAssinadoButton);
